export default __webpack_public_path__ + "static/media/drop-grey.85da6ecd.svg";